<template>
    <div>
        <h2>Facility Nurse Aide Staff Reports</h2>
        <div v-if="loading">Loading, please wait...</div>
        <div v-else>
            <div v-if="semiannuals">
              <br/>
              <br/>
              <div v-if="filter">
                <BaseTextInput v-model="filterString" :v="$v.filterString" label="Name, Last 4 of SSN, or Certificate Number"/>
              </div>
              <div>
                <b-button variant="primary" @click="filter=!filter; filterString=''">{{filter?'Switch to list view':'Switch to filter view'}}</b-button>
              </div>
              <br/>
              <br/>

              <div v-if="filter">
                <b-row>
                  <b-col>
                    <b-table hover small responsive show-empty class="sr-caption"
                             aria-live="polite"
                             :id="slug"
                             :fields="filterFields"
                             :items="filterString?cnaList.filter(c=>(c.firstName+' '+c.lastName).toLowerCase().includes(filterString.toLowerCase())||c.ssn4.includes(filterString)||c.certificateNumber.includes(filterString)):cnaList"
                             primary-key="id"
                             :busy="isLoading"
                             label-sort-asc=""
                             label-sort-desc=""
                    >
                      <template v-slot:cell(endDate)="row">
                        {{formatDate(row.item.endDate)}}
                      </template>
                      <template v-slot:empty="scope">
                        <p>No CNAs matching filter found.</p>
                      </template>
                      <template v-slot:cell(lastWorkedDate)="row">
                        <div>{{formatDate(row.item.lastWorkedDate)}}</div>
                      </template>
                      <template v-slot:cell(lastReportDate)="row">
                        <div>{{formatDate(row.item.lastReportDate)}}</div>
                      </template>
                      <template v-slot:cell(status)="row">
                        <div v-if="row.item.status.code==='OTH'">
                          {{row.item.status.description}}: {{row.item.otherStatus}}
                        </div>
                        <div v-else>
                          {{row.item.status.description}}
                        </div>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <div v-if="row.item.verified.code==='VERIFIED'">
                          <b-button variant="primary" @click="showStatusModal(row.item)">Change Status</b-button>
                        </div>
                        <div v-if="row.item.verified.code==='PENDING'">
                          <b-button variant="primary" @click="showVerifyModal(row.item)">Verification</b-button>
                        </div>
                      </template>
                      <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                                   label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                        <strong>Loading, Please Wait...</strong>
                      </div>
                    </b-table>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <div>Displaying facility nurse aide staff reports from last 2 years:</div>
                <div class="card" v-for="(semiannual, index) in semiannuals" :key="semiannual.id">
                  <div class="card-header">Report {{index+1}} of {{semiannuals.length}}.</div>
                  <div class="card-body">
                    <b-row>
                      <b-col cols="4">
                        <BaseTextOutput label="Report date" :value="formatDate(semiannual.date)"/>
                      </b-col>
                      <b-col cols="4">
                        <b-button variant="primary" @click="downloadReport(semiannual.id)">Print Report</b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-table hover small responsive show-empty class="sr-caption"
                                 aria-live="polite"
                                 :id="slug"
                                 :fields="fields"
                                 :items="semiannual.cnas"
                                 primary-key="id"
                                 :busy="isLoading"
                                 label-sort-asc=""
                                 label-sort-desc=""
                        >
                          <template v-slot:cell(endDate)="row">
                            {{formatDate(row.item.endDate)}}
                          </template>
                          <template v-slot:empty="scope">
                            <p v-if="!filter">No CNAs listed.</p>
                            <p v-else>No CNAs matching filter found.</p>
                          </template>
                          <template v-slot:cell(lastWorkedDate)="row">
                            <div>{{formatDate(row.item.lastWorkedDate)}}</div>
                          </template>
                          <template v-slot:cell(status)="row">
                            <div v-if="row.item.status.code==='OTH'">
                              {{row.item.status.description}}: {{row.item.otherStatus}}
                            </div>
                            <div v-else>
                              {{row.item.status.description}}
                            </div>
                          </template>
                          <template v-slot:cell(actions)="row">
                            <div v-if="row.item.verified.code==='VERIFIED'">
                              <b-button variant="primary" @click="showStatusModal(row.item)">Change Status</b-button>
                            </div>
                            <div v-if="row.item.verified.code==='PENDING'">
                              <b-button variant="primary" @click="showVerifyModal(row.item)">Verification</b-button>
                            </div>
                          </template>
                          <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                            <strong>Loading, Please Wait...</strong>
                          </div>
                        </b-table>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          <div v-else>No reports found for facility...</div>
        </div>


    </div>
</template>

<script>

    import axios from 'axios';
    import moment from 'moment';
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput"
    import * as FileSaver from 'file-saver';
    import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
    export default {
        name: "Semiannuals",
        components: {
            BaseTextOutput,
            BaseTextInput
        },
        data: () => ({
            filter: false,
            filterString: '',
          cnaList: [],
            semiannuals: null,
            fields: [
                {key: 'firstName', label: 'First Name', sortable: true},
                {key: 'lastName', label: 'Last Name', sortable: true},
                {key: 'certificateNumber', label:'Certificate Number',sortable: true},
                {key: 'ssn4', label: 'SSN', sortable: true},
                {key: 'status', label: 'Status', sortable: true},
                {key: 'lastWorkedDate', label: 'Last Worked Date', sortable: true},
            ],
          filterFields: [
            {key: 'firstName', label: 'First Name', sortable: true},
            {key: 'lastName', label: 'Last Name', sortable: true},
            {key: 'certificateNumber', label:'Certificate Number',sortable: true},
            {key: 'ssn4', label: 'SSN', sortable: true},
            {key: 'status', label: 'Status', sortable: true},
            {key: 'lastWorkedDate', label: 'Last Worked Date', sortable: true},
            {key: 'lastReportDate', label: 'Last Report Date', sortable: true}
          ],
            loading: true
        }),
        mounted() {
            this.loadSemiannuals();
        },
        methods: {
            loadSemiannuals() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/semiannual/provider/get`)
                    .then(response => {
                        this.semiannuals = response.data;
                        for(let i=0;i<this.semiannuals.length;i++){
                          for(let j=0;j<this.semiannuals[i].cnas.length;j++){
                            let cna = this.semiannuals[i].cnas[j];
                            if(this.cnaList.findIndex(c=>c.certificateNumber===cna.certificateNumber)===-1){
                              cna = Object.assign({}, cna);
                              cna.lastReportDate = this.semiannuals[i].date;
                              this.cnaList.push(cna);
                            }
                          }
                        }
                        this.loading = false;
                    })
            },
            formatDate(unformattedDate) {
              let formattedDate = moment(unformattedDate);
              if (!formattedDate.isValid()) return 'N/A';
              return formattedDate.format("MM/DD/YYYY");
            },
            downloadReport(id) {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/semiannual/provider/generate/${id}`)
                    .then(response => {
                        const file = response.data;
                        if (file.contentType == null) {
                            return;
                        }
                        const byteString = atob(file.fileData); //deprecated, update later
                        const arrayBuffer = new ArrayBuffer(byteString.length);
                        const int8Array = new Uint8Array(arrayBuffer);
                        for (let i = 0; i < byteString.length; i++) {
                            int8Array[i] = byteString.charCodeAt(i);
                        }
                        const blob = new Blob([int8Array], {type: file.contentType});
                        FileSaver.saveAs(blob, file.name);
                    })
            },
          filterCNAs(){
            return this.filterString?this.cnaList.filter(c=>(c.firstName+' '+c.lastName).toLowerCase().includes(this.filterString.toLowerCase())||c.ssn4.includes(this.filterString)||c.certificateNumber.includes(this.filterString)):this.cnaList;
          }
        },
      validations(){
        return {
          filterString: {required: false}
        }
      },
    }
</script>

<style scoped>

</style>